/**
 * @generated SignedSource<<e30e13e7f3c7da7366bca3779f8b7738>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddRoomDialog_hotel$data = {
  readonly id: string;
  readonly rooms: {
    readonly __id: string;
  };
  readonly " $fragmentType": "AddRoomDialog_hotel";
};
export type AddRoomDialog_hotel$key = {
  readonly " $data"?: AddRoomDialog_hotel$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddRoomDialog_hotel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "search"
    },
    {
      "kind": "RootArgument",
      "name": "sort"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddRoomDialog_hotel",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "sort",
          "variableName": "sort"
        }
      ],
      "concreteType": "RoomConnection",
      "kind": "LinkedField",
      "name": "rooms",
      "plural": false,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Hotel",
  "abstractKey": null
};

(node as any).hash = "13ae2eea7f12045b6f75a02956495c12";

export default node;
